import React, {useState} from "react";
import ContentWMax from "../../Components/PageLayout/ContentWMax";
import PageTitle from "../../Components/PageTitle/PageTitle";

import {Spin} from "antd";

//Скелет страницы
export default function HomePage() {
    const [isLoad] = useState(true);

    return (
        <ContentWMax>
            <PageTitle
                title='Главная'/>

            {isLoad ?
                <>
                    Контент
                </>
                :
                <>
                    <Spin size="small"/> <span className='ml-s'>Загрузка данных...</span>
                </>
            }
        </ContentWMax>
    )
}